module.exports = [
    {"label":"TL", "id":"1", "symbol":"₺" },
    {"label":"USD", "id":"2", "symbol":"$" },
    {"label":"EUR", "id":"3", "symbol":"€" },
    {"label":"AUD", "id":"4", "symbol":"$" },
    {"label":"DKK", "id":"5", "symbol":"kr" },
    {"label":"GBP", "id":"6", "symbol":"£" },
    {"label":"CHF", "id":"7", "symbol":"CHF" },
    {"label":"SEK", "id":"8", "symbol":"kr" },
    {"label":"CAD", "id":"9", "symbol":"$" },
    {"label":"KWD", "id":"10", "symbol":"KD" },
    {"label":"NOK", "id":"11", "symbol":"kr" },
    {"label":"SAR", "id":"12", "symbol":"﷼" },
    {"label":"JPY", "id":"13", "symbol":"¥" },
    {"label":"BGN", "id":"14", "symbol":"лв" },
    {"label":"RON", "id":"15", "symbol":"lei" },
    {"label":"RUB", "id":"16", "symbol":"₽" },
    {"label":"IRR", "id":"17", "symbol":"﷼" },
    {"label":"CNY", "id":"18", "symbol":"¥" },
    {"label":"PKR", "id":"19", "symbol":"₨" },
    {"label":"QAR", "id":"20", "symbol":"﷼" }
]